const jwt = require('jsonwebtoken')
const stringRandom = require('string-random')
const axios = require('axios')

export function EzrevenueClient({ baseUrl, projectId, projectSecret }) {
  const self = {
    decodeToken(token) {
      const decoded = jwt.verify(token, projectSecret, { complete: true })
      const { result } = decoded.payload
      return result
    },
    encodeToken(payload) {
      payload.exp = Date.now() + 30 * 60 // 过期时间，建议当前时间+30分钟
      payload.nonce = stringRandom(32) // 随机字符串，32个字符以内
      const header = { project_id: projectId }
      return jwt.sign(payload, projectSecret, { header })
    },
    sendRequest({ url, content }) {
      return axios({
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'text/plain',
        },
        data: content,
      })
    },
    call(api, params) {
      const token = self.encodeToken({ method: api, params: params })
      const url = baseUrl + '/' + api
      return self
        .sendRequest({ url, content: token })
        .then(function(response) {
          let result = self.decodeToken(response.data)
          return { status: response.status, data: result }
        })
        .catch(error => {
          if (error.response) {
            const { status, data } = error.response
            return { status, data: data }
          }
          return Promise.reject(error)
        })
    },
  }
  return self
}
